<template>
  <v-container>
    <v-row>
      <v-col v-if="loadingData || error" cols="12" class="text-center">
        <template v-if="loadingData">
          <div class="my-10">
            <v-progress-circular size="72" indeterminate color="pink" />
          </div>
          <span class="title"> Loading... </span>
        </template>
        <template v-else-if="error">
          <v-btn color="pink" class="white--text" @click="fetchData">
            <v-icon left> mdi-refresh </v-icon> Refresh
          </v-btn>
        </template>
        <template v-else-if="!data.length">
          <span class="title"> Folder is empty </span>
        </template>
      </v-col>
      <v-col cols="12" v-if="details">
        <v-list>
          <CloudItemList
            dense
            v-for="address in data"
            :key="address.uuid"
            :address="address"
            @delete-address="onDelete"
          />
        </v-list>
      </v-col>
      <template v-else>
        <v-col v-for="address in data" :key="address.uuid" cols="6" sm="4" md="3" lg="2">
          <CloudItemCard :address="address" @delete-address="onDelete" />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>
<script>
import { getFolderData } from "@/api/api";
import CloudItemList from "./Cloud/CloudItemList.vue";
import CloudItemCard from "./Cloud/CloudItemCard.vue";

export default {
  components: {
    CloudItemList,
    CloudItemCard,
  },
  props: {
    details: Boolean,
  },
  data() {
    return {
      data: [],
      loadingData: false,
      error: false,
    };
  },
  computed: {
    currentFolder() {
      return (this.$route.params.path || "").split("&").at(-1) || undefined;
    },
    level() {
      return this.$route.params.level__uuid;
    },
  },
  methods: {
    onDelete(uuid) {
      const index = this.data.findIndex((i) => i.uuid === uuid);
      if (index > -1) this.data.splice(index, 1);
    },
    addData(fileOrFolder) {
      this.data.push(fileOrFolder);
    },

    async fetchData() {
      try {
        this.loadingData = true;
        const response = await getFolderData(this.currentFolder, this.level);
        this.$store.commit("cloud/setName", response.name);
        this.data = response.data;
        this.error = false;
      } catch {
        this.error = true;
      } finally {
        this.loadingData = false;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
